import axios from '@/axios'
import Vue from 'vue'

const state = {
  attachments: []
};

const actions = {
  fetchAttachments({ commit }) {
    axios.get('attachments')
      .then((r) => {
        if (r.data.success) {
          commit('SET_ATTACHMENTS', r.data.attachments);
        }
      })
  }
};

const mutations = {
  SET_ATTACHMENTS(state, attachments) {
    Vue.set(state, 'attachments', attachments);
  }
};

export default {
  state,
  actions,
  mutations
}
